import parse from 'html-react-parser';
import useMediaQuery from '../../../../hooks/useMediaQuery';

export default function Index({ data }) {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const content = parse((isMobile ? data[0]?.html_mobile?.value : data[0]?.html?.value) ?? '');

  return content;
}
